import Axios from 'axios-observable'
import { type Directive, type DirectiveBinding } from 'vue'

const ClickPost: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding): void {
    el.addEventListener('click', () => Axios.post(binding.value.url).subscribe(binding.value.callback))
  },
}
export default ClickPost
